export default __webpack_public_path__ + "static/media/arrow_left_long.fa67da8b.svg";